import { createSelector } from 'reselect';

import { ActionRef } from '@/App/types/actionRef';
import { ScreenRef } from '@/App/types/screenRef';
import { getDisplayRulesState } from '@/features/displayRules/getDisplayRulesState';
import { selectDisplayRuleStateMap } from '@/features/displayRules/selectDisplayRuleStateMap';

export const selectDisplayRuleType = (screen: ScreenRef, action: ActionRef, id: string) =>
  createSelector([selectDisplayRuleStateMap], (displayRules) => {
    const currentState = getDisplayRulesState(displayRules, screen, action);
    return currentState ? (currentState[id] ? currentState[id]!.displayRuleType : null) : null;
  });
